import {Component, OnInit} from '@angular/core';
import {Column} from '../../share/models/column';
import {AnnouncementFilterCriteria} from '../../models/filter/announcement-filter-criteria';
import {Announcement} from '../../models/announcement';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {AnnouncementService} from '../../services/announcement.service';
import {UserService} from '../../generated/api/user.service';
import {BaseClientComponent} from '../base-client.component';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {HttpClient} from '@angular/common/http';
import * as _ from 'lodash';

@Component({
  selector: 'app-announcement-log',
  templateUrl: './announcement-log.component.html',
  styleUrls: ['./announcement-log.component.scss']
})
export class AnnouncementLogComponent extends BaseClientComponent implements OnInit {

  supportEmailAddress = 'support@mckay-brothers.com';
  urgentEmailAddress = 'urgent@mckay-brothers.com';
  onboardingEmailAddress = 'onboarding@mckay-brothers.com';

  cols: Column[];
  announcementFilterCriteria: AnnouncementFilterCriteria;
  announcementPreFilterCriteria: AnnouncementFilterCriteria;
  usersItems: any;
  announcement: Announcement;
  size: number;
  announcementList: Announcement[];
  page: number;
  rows: number;
  isMckayUser: boolean;
  display: boolean;
  srcImg: string;
  title: string;
  permission: boolean;
  filtered: boolean;

  userChoicesFiltersDefaultAnnouncementLog = {
    'subject': null,
    'message': null,
    'fromMail': null,
    'user': null,
    'sentDateFrom': null,
    'sentDateTo': null,
    'uuid': null,
  };
  loadingListUsers = true;
  userChoicesActiveFilters = _.clone(this.userChoicesFiltersDefaultAnnouncementLog);
  users = [];

  constructor(public authenticationService: AuthenticationService,
              private announcementService: AnnouncementService,
              private userService: UserService,
              protected utilsService: UtilsService,
              protected http: HttpClient) {
    super();
  }

  ngOnInit() {
    this.filtered = false;
    this.isMckayUser = this.authenticationService.getUserCurrent().permissions.isMckayUser;
    this.permission = this.authenticationService.getUserCurrent().permissions.canAccessRecipients;
    this.display = false;
    this.userChoicesActiveFilters = this.utilsService.loadUserPref('announcementLogFilter', this.userChoicesFiltersDefaultAnnouncementLog);
    this.announcementFilterCriteria = new AnnouncementFilterCriteria(this.userChoicesActiveFilters);
    this.announcementPreFilterCriteria = new AnnouncementFilterCriteria(this.userChoicesActiveFilters);
    this.rows = 20;
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.filtered = true;
      this.getCompanyAdminUsers();
      this.initializeColumns();
      this.search();
    });
    this.subscriptions.push(response$);
  }

  private initializeColumns() {
    this.cols = [];
    if (this.permission) {
      this.cols = [
        {field: 'sentAt', header: 'Sent Date', type: 'string', sortable: false, width: '10%'},
        {field: 'subject', header: 'Announcement Subject', type: 'string', sortable: false, width: '59%'},
        {field: 'user', header: 'Sending user', type: 'string', sortable: false, width: '10%'},
        {field: 'fromAddress', header: 'From Address', type: 'string', sortable: false, width: '15%'},
        {field: 'actions', header: 'List Recipients', sortable: false, type: 'date', width: '6%'}
      ];
    } else {
      this.cols = [
        {field: 'sentAt', header: 'Sent Date', type: 'string', sortable: true, width: '15%'},
        {field: 'subject', header: 'Announcement Subject', type: 'string', sortable: true, width: '65%'},
        {field: 'fromAddress', header: 'From Address', type: 'string', sortable: false, width: '20%'}
      ];
    }
  }

  private getCompanyAdminUsers() {
    this.userService.getUserCollection(this.authenticationService.getUserCurrent().company.uniqid).subscribe(
      users => {
        this.users = users;
        this.usersItems = [];
        this.usersItems.push({label: '', value: ''});
        [...users].sort((a, b) => a.name.localeCompare(b.name)).forEach(user => {
          this.usersItems.push({label: user.name, value: user.name});
        });
        this.loadingListUsers = false;
      }
    );
  }

  loadLazy(event: any) {
    this.page = (event.first / 20) + 1;
    this.rows = event.rows;
    if (this.filtered) {
      this.filter();
    }
  }

  search() {
    this.page = 1;
    this.announcementFilterCriteria = _.clone(this.announcementPreFilterCriteria);
    this.announcementPreFilterCriteria.uuid = null;
    this.initFilterFields();
    this.announcementService.getAnnouncementsNumber(this.announcementFilterCriteria)
      .subscribe((size) => {
        this.size = size;
        this.filter();
      });
  }

  initFilterFields(): void {
    if (this.announcementFilterCriteria.subject === '') {
      this.announcementFilterCriteria.subject = null;
    }
    if (this.announcementFilterCriteria.fromMail === '') {
      this.announcementFilterCriteria.fromMail = null;
    }
    if (this.announcementFilterCriteria.message === '') {
      this.announcementFilterCriteria.message = null;
    }
  }

  filter() {
    this.initFilterFields();
    if (this.isMckayUser) {
      let userId = null;
      if (this.announcementFilterCriteria.user !== '') {
        const user = this.users.filter(userItem => userItem.name === this.announcementFilterCriteria.user);
        userId = (user[0]) ? user[0].id : null;
      }
      this.announcementService.filterAnnouncements(this.announcementFilterCriteria, this.page, userId)
        .subscribe((announcements) => {
          this.announcementList = announcements['member'];
        });
    } else {
      this.announcementService.filterAnnouncementsClients(this.announcementFilterCriteria, this.page)
        .subscribe((announcements) => {
          this.announcementList = announcements['member'];
        });
    }
    this.utilsService.saveUserData('announcementLogFilter',
      {
        'subject': this.announcementFilterCriteria.subject,
        'fromMail': this.announcementFilterCriteria.fromMail,
        'user': this.announcementFilterCriteria.user,
        'sentDateFrom': this.announcementFilterCriteria.sentDateFrom,
        'sentDateTo': this.announcementFilterCriteria.sentDateTo,
        'uuid': null,
        'message': this.announcementFilterCriteria.message
      });
  }

  reset() {
    this.utilsService.saveUserData('announcementLogFilter',
      this.userChoicesFiltersDefaultAnnouncementLog);
    this.announcementFilterCriteria = new AnnouncementFilterCriteria(this.userChoicesFiltersDefaultAnnouncementLog);
    this.announcementPreFilterCriteria = new AnnouncementFilterCriteria(this.userChoicesFiltersDefaultAnnouncementLog);
    this.search();
  }

  openMessage(announcement: Announcement) {
    this.title = 'From: ' + announcement.announcementSentMessage[0].fromMail + '\n' + 'Subject: ' + announcement.subject;
    this.announcement = announcement;
    if (this.announcement.announcementSentMessage[0].fromMail.indexOf('mckay-brothers') !== -1) {
      this.srcImg = '../../../assets/images/logo-mckay.png';
      this.supportEmailAddress = 'support@mckay-brothers.com';
      this.urgentEmailAddress = 'urgent@mckay-brothers.com';
      this.onboardingEmailAddress = 'onboarding@mckay-brothers.com';
    } else {
      this.srcImg = '../../../assets/images/logo-quincy.png';
      this.supportEmailAddress = 'support@quincy-data.com';
      this.urgentEmailAddress = 'urgent@quincy-data.com';
      this.onboardingEmailAddress = 'onboarding@quincy-data.com';
    }
    this.display = true;
  }

}
